{
  "help": "Hjälp",
  "info": "Information"
}
